import { call, put, takeEvery } from 'redux-saga/effects'

// Helper for api errors
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'
let clientApi = axiosApi()

// Our login constants
import {
  RESEND_RESETPW_CODE_REQUESTING,
  RESEND_RESETPW_CODE_SUCCESS,
  RESEND_RESETPW_CODE_ERROR,
  RESEND_RESETPW_CODE_URL,
} from './constants'

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function resendResetPwCodeApi (formData) {
  const request = clientApi.post(RESEND_RESETPW_CODE_URL, 
    formData
  );
  return handleRequest(request);
}

function* resendResetPwCodeFlow (action) {
  try {
    const { formData } = action
    var result = yield call(resendResetPwCodeApi, formData)
    if (result.code != 200) {
      yield put({ type: RESEND_RESETPW_CODE_ERROR, error: result.message })
    } else {
      yield put({ type: RESEND_RESETPW_CODE_SUCCESS, message: result.message })
    }
    
  } catch (error) {
    // error? send it to redux
    yield put({ type: RESEND_RESETPW_CODE_ERROR, error })
  }
}

// Our watcher (saga).  It will watch for many things.
function* resendResetPwCodeWatcher () {
  yield takeEvery(RESEND_RESETPW_CODE_REQUESTING, resendResetPwCodeFlow)
}

export default resendResetPwCodeWatcher



// WEBPACK FOOTER //
// ./src/views/Pages/ResendResetPwCode/sagas.js